
window.LayWheeler = window.LayWheeler || {};

LayWheeler.Basket = (function ($, document, ns) {
    ns = ns || {};
    ns.UpdateSummary = function () {
        $.get('/api/basket/summary', function (result) {
            var $basket = $('[data-basket-summary]');
            $('.icon__label', $basket).text($basket.data('basket-default-content') + ' ' + result.BasketTotal);
            var $icon = $('.icon', $basket);
            $icon.removeClass('icon__notification--long');

            if (result.NumberOfItems == 0) {
                delete $icon[0].dataset.notification;
            } else if (result.NumberOfItems >= 100) {
                $icon[0].dataset.notification = '99+';

                $icon
                    .addClass('icon__notification--long')
                    ;
            } else {
                $icon[0].dataset.notification = result.NumberOfItems;
            }
        });
    };

    return ns;

})(jQuery, document, LayWheeler.Basket);